import ajax from './ajax.js'
import qs from 'qs'  //ajax请求
import mothed from './motheds.js'
//获取URL查询字符串值
function getURLSearchParams(params){
    if(!isArray(params)) return;
    param = qs.stringify(params)
    return param
}
//判断是数组
function isArray(o){
    return Object.prototype.toString.call(o)=='[object Array]';
}


/* =============================================
 * 				 ajax请求列表
 *
 *		将需要用到的API进行整合， 通过axios来执行XMLhttprequest数据获取，
 *		最后通过 getAjax 方法导出统一的接口
 * =============================================  */


let apiList = {

    //超市
	//首页列表
	indexList: {
		url: '/api/content/'+mothed.codeLink()+'/mechanInfo',
        params: {type: 2},
        type: "get"
    },
    //首页产品列表
    product: {
		url: '/api/content/'+mothed.codeLink()+'/product',
        params: {},
        type: "post"
    },
    //productType无数据时首页产品列表
    products: {
		url: '/api/content/'+mothed.codeLink()+'/products',
        params: {},
        type: "post"
    },
    //机构首页产品分类
    productTypeNew: {
		url: '/api/content/'+mothed.codeLink()+'/productType',
        params: {},
        type: "post"
    },
    //机构首页我的产品(包含自定义)
    typeProduct:{
        url: '/api/content/'+mothed.codeLink()+'/typeProduct',
        params: {},
        type: "post"
    },
    //工具栏接口
    toolBar:{
        url: '/api/content/'+mothed.codeLink()+'/toolBar',
        params: {},
        type: "post"
    },
    //微信分享
    jssdksign: {
		url: '/msg/center/get/jssdksign',
        params: {},
        type: "get"
    },
    //
    //查询产品导航
    productType:{
        url: '/api/content/'+mothed.codeLink()+'/productTypes',
        params: {},
        type:"get"
    },
    //查询产品列表
    productList:{
        url: '/api/content/'+mothed.codeLink()+'/getProducts',
        params: {}
    },
    // 查询保单
    getPolicys:{
        url: '/api/content/compensation/apply',
        params: {}
    },
    // 查询保单 根据手机号查询
    getPolicys2:{
        url: '/api/content/getPolicys',
        params: {}
    },
    //提交理赔信息
    saveSettle:{
        url: '/api/content/'+(mothed.codeLink()||"bz0181120572")+'/compensation/save',
        params: {}
    },
    //查询理赔保单
    getSettles:{
        url: '/api/content/'+(mothed.codeLink()||"bz0181120572")+'/compensation/getCompensation',
        params: {}
    },
    //查询电子保单
    policyDetail:{
        url: '/api/content/download/e-policy',
        params: {},
        type:"get"
    },
    //获取token
    getToken:{
        url: '/api/content/getToken',
        params: {},
        type:"get"
    },
    saveSubscribeService:{
        url: '/api/content/saveSubscribeService',
        type:"put"
    },
    saveAppointment:{
      url:'/api/subscribe/xingbei/resource/save',
      type:'post'
    },
    querySubscribePayResult:{
      url:'/api/content/querySubscribePayResult',
      type:'put'
    },
    sendCode:{
        url: '/master/user/sendCode',
        type:"post"
    },
    queryAllShuang11Product:{
        url: '/plat/giftBindRecord/api/queryAllShuang11Product',
        type:"get"
    },
    //
    whetherExistCreateOrderQuantity:{
        url: '/plat/giftBindRecord/api/queryGiftQuantity',
        type:"post"
    },
    mechanConfig:{
        url:'/api/content/'+(mothed.codeLink()||'bz0181120572')+'/mechanConfig',
        type:'get'
    },
    detailData:{
        url:'/api/content/compensation/detail',
        type:'get'
    },
    saveResult:{
        url:'/api/hbzs/saveResult',
        type:'post'
    },
    querySysUserConfig:{
        url:'/api/content/querySysUserConfig',
        type:'put'
    },
    queryUrl:{
        url:'/api/content/subscribeService/queryUrl',
        type:'put'
    },
    // 单独传入url
    none: {
        url: ''
    },
    phoneSignature:{
      url: '/master/user/getSignature',
      type: 'put'
    },
    commonSignature:{
      url: '/api/content/getSignature',
      type: 'put'
    },
};

//获取AJAX请求 数据
function getHttp(param,success,failure){
    let data=apiList[param.name];
    if(!data){
      data = {}
    }
    var params;
    if(param.url){
        data.url = param.url;
    }
    if (param.type) {
        data.type = param.type
    }
    if(param.params){
        params=param.params
    }else{
        params=data.params;
    }
    if(!data.type || data.type=="post"){
        ajax.post(data.url,params,success,failure);
    }else if(data.type=="get"){
        ajax.get(data.url,params,success,failure);
    }
    else if(data.type=="put"){
        ajax.put(data.url,params,success,failure);
    }
}

export default {
    getHttp
}



// WEBPACK FOOTER //
// ./src/api/httpList.js